import LoadingSpinner from "components/LoadingSpinner";
import { useGetVendorsQuery } from "features/vendor/vendorSlice"
import { PricingLookupStyle } from "./style";
import { useGetActivityPricingByParametersQuery } from "../pricingSlice";
import { Button, IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import FormatService from "services/formatService";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { useState } from "react";
import { useEffect } from "react";

export const PricingLookup = ({ onChange, activityItemId, lotId, vehicleTypeId, vendorId, setVendorId, price, setUseInventory, setNotSupported, clientId }) => {
    const classes = PricingLookupStyle()

    let { data: prices, error: pricesError, isLoading: isLoadingPrices } = useGetActivityPricingByParametersQuery({ activityItemId, lotId, vehicleTypeIds: vehicleTypeId, includeAllResults: true, clientId }, { skip: !activityItemId || !lotId || !vehicleTypeId });
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();

    const vendorsLookup = vendors?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    prices = prices?.find(p => p.vehicleType == vehicleTypeId)?.activityPrices?.map(activityPrice => {
        return {
            ...activityPrice,
            vendor: vendorsLookup?.[activityPrice?.vendorId]?.name,
            formattedPrice: FormatService.formatCurrency(activityPrice?.internalCost),
        }
    });

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (price === 0 || price === undefined || isNaN(price) || price === "") {

            let priceObject = prices?.find(p => p.vendorId == vendorId)

            onChange(priceObject?.internalCost);

            priceObject?.useInventory ? setUseInventory(true) : setUseInventory(false);
        }
    }, [vendorId]);


    return <>
        <LoadingSpinner loading={isLoadingVendors || isLoadingPrices} />
        {
            (!!activityItemId && !!lotId && !!vehicleTypeId) &&
            <>
                <Tooltip title='Lookup Price'>
                    <IconButton
                        onClick={handleClick}

                    >
                        <LocalAtmIcon />
                    </IconButton>
                    {/* <Button
                        onClick={handleClick}
                        variant="contained"
                        color="primary"
                        className={classes.calculateButton}
                    >
                        Lookup
                    </Button> */}
                </Tooltip>

                <Menu
                    id="pricing-list"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    {prices?.map((value, key) => (
                        <MenuItem onClick={() => {
                            setNotSupported(value.notSupported);
                            onChange(value?.internalCost);
                            setVendorId(value?.vendorId);
                            setUseInventory(value?.useInventory);
                            handleClose();
                        }} >
                            Vendor: {value.vendor}, Price: {value.formattedPrice}
                        </MenuItem>
                    ))}

                    {prices?.length == 0 &&
                        <MenuItem disabled >
                            There are no prices in the price database
                            <br />
                            for this activity, lot and vehicle type
                        </MenuItem>
                    }
                </Menu>
            </>
        }
    </>

}